import { LoadState } from "../../constants/enums";
import { ICourse, IOrganization, IOrganizationState, ISession } from "./type";

export const defaultCourse:ICourse={
    courses_id: 0,
    courses_unique_id: 0,
    courses_uuid: null,
    courses_name: "",
    courses_duration: "",
    session_info_uuid: "",
    session_name: "",
    session_duration_in_years: "",
    organizations_uuid: "",
    organizations_name: "",
    status: "", // Assuming "INACTIVE" is a valid default status
    created_by_uuid: "",
    created_by_name: "",
    modified_by_uuid: "",
    modified_by_name: "",
    create_ts: "",
    insert_ts: ""
}

export const defaultOrganization:IOrganization={
    organizations_id: 0,
    organizations_unique_id: 0,
    organizations_uuid: "",
    organizations_name: "",
    status: "ACTIVE",
    created_by_uuid: "",
    created_by_name: "",
    modified_by_uuid: "",
    modified_by_name: "",
    create_ts: null,
    insert_ts: ""
}

export const defaultSessionInfo: ISession = {
    session_info_id: null,
    session_info_unique_id: null,
    session_info_uuid: '',
    session_name: '',
    session_duration_in_years: '',
    session_starting_date: '',
    session_ending_date: '',
    status: 'ACTIVE', // Default status can be adjusted
    created_by_uuid: '',
    created_by_name: '',
    modified_by_uuid: '',
    modified_by_name: '',
    create_ts: '',
    insert_ts: '',
  };


  export const defaultOrganizationState:IOrganizationState={
    organization:{
        list: [],
        data: defaultOrganization,
        loading: LoadState.NotLoaded,
        totalRecords: 0,
        error: null
    },
    course:{
        list: [],
        data: defaultCourse,
        loading: LoadState.NotLoaded,
        totalRecords: 0,
        error: null
    },
    session:{
        list: [],
        data: defaultSessionInfo,
        loading: LoadState.NotLoaded,
        totalRecords: 0,
        error: null
    }
  }